import * as Phaser from "phaser";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { SatietyIndicator } from "./SatietyIndicator.ts";
import { CleanIndicator } from "./CleanIndicator.ts";
import { EnergyIndicator } from "./EnergyIndicator.ts";
import { MoodIndicator } from "./MoodIndicator.ts";

export class RoomIndicatorPanel extends Phaser.GameObjects.Container {
  constructor(private myScene: BasicScene, x: number, y: number) {
    super(myScene, x, y);

    const step = 85;

    const satietyIndicator = new SatietyIndicator(myScene, 0, 0);
    this.add(satietyIndicator);

    const moodIndicator = new MoodIndicator(
      myScene,
      satietyIndicator.x - step,
      0,
    );
    this.add(moodIndicator);

    const energyIndicator = new EnergyIndicator(
      myScene,
      moodIndicator.x - step,
      0,
    );
    this.add(energyIndicator);

    const cleanIndicator = new CleanIndicator(
      myScene,
      energyIndicator.x - step,
      0,
    );
    this.add(cleanIndicator);

    // this.myScene.time.addEvent({
    //   delay: 5000,
    //   callback: () => {
    //     satietyIndicator.setValue(this.myScene.storage.pet().satiety);
    //     cleanIndicator.setValue(this.myScene.storage.pet().clean);
    //     energyIndicator.setValue(this.myScene.storage.pet().energy);
    //     moodIndicator.setValue(this.myScene.storage.pet().mood);
    //   },
    //   loop: true,
    // });
  }
}
